"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = App;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _actions = require("../actions");
var _selectors = require("../selectors");
var _r10SourceLibrary = require("r10-source-library");
var _useProps2 = _interopRequireDefault(require("../hooks/useProps"));
var _useConfig6 = _interopRequireDefault(require("../hooks/useConfig"));
var _jsonpathPlus = require("jsonpath-plus");
var _Header = _interopRequireDefault(require("./blocks/Header"));
var _SubHeader = _interopRequireDefault(require("./blocks/SubHeader"));
var _Loading = _interopRequireDefault(require("./blocks/Loading"));
var _SimServiceItem = _interopRequireDefault(require("./SimServiceItem"));
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
var _ErrorComponent = _interopRequireDefault(require("./blocks/ErrorComponent"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } // @ts-ignore: Unreachable code error
var WidgetContainer = (0, _styledComponents.default)('div')({
  margin: '0 auto'
}, function (props) {
  var _props$maxWidth;
  return {
    maxWidth: (_props$maxWidth = props.maxWidth) !== null && _props$maxWidth !== void 0 ? _props$maxWidth : '630px'
  };
});
function App() {
  var t = (0, _useTranslation.default)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useProps = (0, _useProps2.default)(),
    __instanceId = _useProps.__instanceId;
  var _useConfig = (0, _useConfig6.default)('widgetCustomization'),
    _useConfig$premiumSms = _useConfig.premiumSms,
    premiumSms = _useConfig$premiumSms === void 0 ? [] : _useConfig$premiumSms;
  var _useConfig2 = (0, _useConfig6.default)('widgetCustomization'),
    _useConfig2$maxWidth = _useConfig2.maxWidth,
    maxWidth = _useConfig2$maxWidth === void 0 ? '630px' : _useConfig2$maxWidth;
  var _useConfig3 = (0, _useConfig6.default)('jsonPaths'),
    _useConfig3$msisdnPat = _useConfig3.msisdnPath,
    msisdnPath = _useConfig3$msisdnPat === void 0 ? '' : _useConfig3$msisdnPat;
  var _useConfig4 = (0, _useConfig6.default)('otherWidgets'),
    sliceNameWithMsisdn = _useConfig4.sliceNameWithMsisdn;
  var _useConfig5 = (0, _useConfig6.default)('requestSettings'),
    _useConfig5$barringSe = _useConfig5.barringServiceName,
    barringServiceName = _useConfig5$barringSe === void 0 ? {} : _useConfig5$barringSe;
  var _barringServiceName$r = barringServiceName.requestBody,
    requestBody = _barringServiceName$r === void 0 ? {
      name: 'Barring Service Name',
      role: 'subscriber',
      valueType: 'string',
      barred: 'Barred',
      unbarred: 'UnBarred'
    } : _barringServiceName$r;
  var name = requestBody.name,
    role = requestBody.role,
    valueType = requestBody.valueType,
    barred = requestBody.barred,
    unbarred = requestBody.unbarred;
  var instanceId = (0, _reactRedux.useSelector)(_selectors.getInstanceId);
  var refreshStatus = (0, _reactRedux.useSelector)(_selectors.getRefreshStatus);
  var otherWidgetState = (0, _reactRedux.useSelector)((0, _selectors.getOtherWidgetSlice)(sliceNameWithMsisdn)) || {};
  var _JSONPath = (0, _jsonpathPlus.JSONPath)({
      path: msisdnPath,
      json: otherWidgetState
    }),
    _JSONPath2 = _slicedToArray(_JSONPath, 1),
    msisdn = _JSONPath2[0];
  var smsPatchError = (0, _reactRedux.useSelector)(_selectors.getSmsPatchError);
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.getSmsBarringData),
    _useSelector2 = _slicedToArray(_useSelector, 1),
    smsBarringData = _useSelector2[0];
  var loading = (0, _reactRedux.useSelector)(_selectors.getLoading);
  var smsFetchError = (0, _reactRedux.useSelector)(_selectors.getSmsFetchError);
  function handleStatusChange(barNumber, barStatus) {
    var postData = {
      name: name,
      relatedParty: [{
        id: msisdn,
        role: role
      }],
      serviceCharacteristic: [{
        name: barNumber,
        value: barStatus ? unbarred : barred,
        valueType: valueType
      }]
    };
    dispatch((0, _actions.setBarringStatus)({
      msisdn: msisdn,
      postData: postData,
      barNumber: barNumber
    }));
  }
  var getBarringData = function getBarringData() {
    if (msisdn) {
      dispatch((0, _actions.getBarringStatus)(msisdn));
    }
  };
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.setInstanceId)(__instanceId));
  }, [__instanceId]);
  (0, _react.useEffect)(function () {
    if (instanceId) getBarringData();
  }, [instanceId, msisdn]);
  (0, _react.useEffect)(function () {
    if (refreshStatus) getBarringData();
  }, [refreshStatus]);
  if (loading) {
    return /*#__PURE__*/_react.default.createElement(WidgetContainer, {
      maxWidth: maxWidth
    }, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement(_SubHeader.default, null), /*#__PURE__*/_react.default.createElement(_Loading.default, null));
  }
  if (smsFetchError) {
    return /*#__PURE__*/_react.default.createElement(WidgetContainer, {
      maxWidth: maxWidth
    }, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement(_SubHeader.default, null), /*#__PURE__*/_react.default.createElement(_ErrorComponent.default, {
      buttonAction: function buttonAction() {
        return getBarringData();
      }
    }));
  }
  return /*#__PURE__*/_react.default.createElement(WidgetContainer, {
    maxWidth: maxWidth
  }, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement(_SubHeader.default, null), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    elevation: true
  }, smsBarringData && premiumSms.length > 0 && premiumSms.map(function (service, index) {
    var title = service.title,
      iconName = service.iconName,
      barNumber = service.barNumber,
      statusPath = service.statusPath;
    var _JSONPath3 = (0, _jsonpathPlus.JSONPath)({
        path: statusPath,
        json: smsBarringData
      }),
      _JSONPath4 = _slicedToArray(_JSONPath3, 1),
      barStatus = _JSONPath4[0];
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      "data-testid": "barring-management-sim-service-item-".concat(index)
    }, /*#__PURE__*/_react.default.createElement(_SimServiceItem.default, {
      barNumber: barNumber,
      iconName: iconName,
      serviceTitle: t(title),
      barStatus: barStatus ? true : false,
      error: (smsPatchError === null || smsPatchError === void 0 ? void 0 : smsPatchError.barNumber) === barNumber ? true : false,
      handleStatusChange: handleStatusChange,
      index: index
    }), index < premiumSms.length - 1 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
      noMargin: true,
      appearance: "secondary"
    }));
  })));
}